export class Network {
    private available: string[];
    private preferred: string | null | undefined;

    constructor(available: string[], preferred: string | null | undefined) {
        this.setAvailable(available);
        this.setPreferred(preferred);
    }

    static fromJson(json:any) {
        return new Network(json.available, json.preferred);
    }

    setAvailable(newAvailable:string[]) {
        this.available = newAvailable;
    }
    setPreferred(newPreferred:string | null | undefined) {
        this.preferred = newPreferred;
    }

    getAvailable() {
        return this.available;
    }
    getPreferred() {
        return this.preferred;
    }
}